import { backgroundThemes } from 'design-system';

export const RIVAS_BATTLE_DAY_BACKGROUND =
  'url("../svg/rivas_battle_login_day.svg")';
export const RIVAS_BATTLE_NIGHT_BACKGROUND =
  'url("../svg/rivas_battle_login_night.svg")';
export const JULY_DAY_BACKGROUND = 'url("../svg/july_login_day.svg")';
export const JULY_NIGHT_BACKGROUND = 'url("../svg/july_login_night.svg")';
export const INDEPENDENCE_DAY_BACKGROUND =
  'url("../svg/independence_login_day.svg")';
export const INDEPENDENCE_NIGHT_BACKGROUND =
  'url("../svg/independence_login_night.svg")';

type MonthBackground = {
  month: number;
  day: string;
  night: string;
};

const rivasBattleBackground: MonthBackground = {
  month: 4,
  day: RIVAS_BATTLE_DAY_BACKGROUND,
  night: RIVAS_BATTLE_NIGHT_BACKGROUND,
};

const julyBackground: MonthBackground = {
  month: 7,
  day: JULY_DAY_BACKGROUND,
  night: JULY_NIGHT_BACKGROUND,
};

const independenceBackground: MonthBackground = {
  month: 9,
  day: INDEPENDENCE_DAY_BACKGROUND,
  night: INDEPENDENCE_NIGHT_BACKGROUND,
};

const xmasBackground: MonthBackground = {
  month: 12,
  day: backgroundThemes.XMAS_DAY_BACKGROUND,
  night: backgroundThemes.XMAS_NIGHT_BACKGROUND,
};

const defaultBackground: MonthBackground = {
  month: 0,
  day: backgroundThemes.DEFAULT_DAY_BACKGROUND,
  night: backgroundThemes.DEFAULT_NIGHT_BACKGROUND,
};

const backgroundList: MonthBackground[] = [
  rivasBattleBackground,
  julyBackground,
  independenceBackground,
  xmasBackground,
];

export function getLoginBackgroundImage(date: Date, isNight: boolean): string {
  const month = date.getMonth() + 1;
  const background: MonthBackground =
    backgroundList.find((bg) => bg.month === month) || defaultBackground;
  return isNight ? background.night : background.day;
}
